import { createContext, useContext } from 'react'

export type MobileNavApi = {
  open: () => void
}

const MobileNavContext = createContext<MobileNavApi>({ open: () => {} })

export const MobileNavProvider = MobileNavContext.Provider

export function useMobileNav(): MobileNavApi {
  return useContext(MobileNavContext)
}
